import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {Popover, PopoverRef, Position} from '@greetgo/popover';
import {ActiveDescendantKeyManager} from '@angular/cdk/a11y';
import {ENTER, ESCAPE} from '@angular/cdk/keycodes';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {AutocompleteOptionComponent} from './autocomplete-option.component';
import {BoAutocompleteOption} from '../model/BoAutocompleteOption';
import {FormFieldType} from '../model/FormFieldType';
import {DYNAMIC_FORMS_SERVICE, DynamicFormsService} from '../lib/DynamicFormsService';
import {DynamicFormInnerService} from '../lib/dynamic-form-inner.service';

const PHONE_REGEXP = /^[\d+\-()\s]+$/;
const EMAIL_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;


@Component({
  selector: 'app-dff-input',
  templateUrl: './dff-input.component.html',
  styleUrls: ['./dff-input.component.scss'],
})
export class DffInputComponent extends AbstractDynamicFormFieldDirective {

  @ViewChild('overlay', {static: true}) overlay !: TemplateRef<any>;
  @ViewChild('origin', {static: true}) origin !: HTMLDivElement;
  @ViewChildren(AutocompleteOptionComponent) optionItem !: QueryList<AutocompleteOptionComponent>;

  private popoverRef: PopoverRef;
  private popoverOpened: boolean;
  private keyManager: ActiveDescendantKeyManager<AutocompleteOptionComponent | null>;

  autocompleteOptions: BoAutocompleteOption[];
  value = '';

  constructor(
    @Inject(DYNAMIC_FORMS_SERVICE) service: DynamicFormsService,
    innerService: DynamicFormInnerService,
    elRef: ElementRef,
    private readonly popover: Popover,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) { super(service, innerService, elRef); }

  getInputType(field: FormFieldType): string {
    if (field === FormFieldType.INPUT_PHONE
      || field === FormFieldType.INPUT_EMAIL
      || field === FormFieldType.INPUT_TEXT) { return 'text'; }

    if (field === FormFieldType.INPUT_NUMBER) { return 'number'; }
  }

  validate(value: string) {
    const ret: string[] = [];

    if (value) {

      if (this.field.type === FormFieldType.INPUT_EMAIL) {
        if (!EMAIL_REGEXP.test(value)) {
          ret.push('validate_need_email');
        }
      }

      if (this.field.type === FormFieldType.INPUT_PHONE) {

        if (!PHONE_REGEXP.test(value)) {
          ret.push('validate_need_phone');
        }

      }

    }

    return ret;
  }

  writeValue(value: string) {
    this.value = value;
  }

  showAutocomplete(value: BoAutocompleteOption[]) {
    this.autocompleteOptions = value;
    if (this.popoverOpened && this.autocompleteOptions.length === 0) {
      this.popoverRef.close();
      return;
    }

    if (this.popoverOpened) { return; }
    if (value && value.length) {
      this.popoverOpened = true;
      const position = Position.bottom;
      const color = 'white';
      const hasBackdrop = true;
      const origin = this.origin;
      const content = this.overlay;
      const needArrow = false;
      const withPush = false;
      this.popoverRef = this.popover.open({origin, content, position, color, hasBackdrop, needArrow, withPush});
      this.popoverRef.beforeClosed.subscribe(() => this.popoverOpened = false);
      this.changeDetectorRef.detectChanges();
      this.keyManager = new ActiveDescendantKeyManager(this.optionItem).withWrap();
    }
  }

  closeAutocomplete() {
    if (this.popoverRef) { this.popoverRef.close(); }
  }

  autoCompleteOptionClicked(option: BoAutocompleteOption) {
    this.closePopover();
    this.innerService.autocompleteClick(option);
  }

  getId(index, value: BoAutocompleteOption) {
    return value.boInstanceId;
  }

  onKeydown(event) {
    if (event.keyCode === ENTER) {
      if (this.keyManager) {
        const activeItem = this.keyManager.activeItem as AutocompleteOptionComponent;
        const autoCompleteOption = activeItem.option;
        this.autoCompleteOptionClicked(autoCompleteOption);
      }
    } else if (event.keyCode === ESCAPE) {
      this.closePopover();
      event.stopPropagation();
    } else {
      if (!this.keyManager) { return; }
      this.keyManager.onKeydown(event);
    }
  }

  private closePopover() {
    this.popoverRef?.close();
  }


}
